import axios from 'axios'
import customConfig from '/customConfig.js'

const instance = axios.create({
    baseURL: customConfig.shareConfig.shareBaseUrl,
    // baseURL: 'https://www.fastmock.site/mock/ae8e9031947a302fed5f92425995aa19/jd',
    timeout: 60000
})

export const get = (url, params = {}) => {
    return new Promise((resolve, reject) => {
        instance.get(url, { params }).then((response) => {
            resolve(response.data)
        }, err => {
            reject(err)
        })
    })
}

export const post = (url, data = {}) => {
    return new Promise((resolve, reject) => {
        instance.post(url, data, {
            headers: {
                'Content-Type': 'application/json',
                token: localStorage.token
            }
        }).then((response) => {
            resolve(response.data)
        }, error => {
            if (error.response) {
                switch (error.response.status) {
                    case 401:
                        // 返回 401 清除token信息并重新拉取授权
                        localStorage.token = ''
                        location.reload()
                }
            }
            reject(error)
        })
    })
}
